module.exports = __webpack_public_path__ + "media/images/front/clinicwiki/default-0c3808d2aa83c245dc630e3ae5f567f6.png";